export default __webpack_public_path__ + "static/media/homepage-mobile5.e2c9c2b0.jpg";